import { Icon, Radio, RadioGroup, Spacing, Text } from '@billy/design-system'
import { ChangeEvent, ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { TransactionTypeFilter } from '@features/bankTransactions/enums/transactionTypeFilter'

interface SideFilterProps {
  value?: TransactionTypeFilter
  onChange: (value: TransactionTypeFilter) => void
}

export const SideFilter = ({ value, onChange }: SideFilterProps): ReactElement => {
  const { t } = useTranslation()
  const handleChange = useCallback(
    ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
      if (value === TransactionTypeFilter.Credit || value === TransactionTypeFilter.Debit) {
        onChange(value)
      }
    },
    [onChange],
  )

  return (
    <>
      <Text colorVariant="discreet" weight="semiBold">
        {t('bank_transactions.filter.transaction_type')}
      </Text>
      <RadioGroup
        key={`transaction-side-${value ?? ''}`}
        name="transactionSideFilter"
        value={value}
        onChange={handleChange}
        direction="column"
        spacing={Spacing.S20}
      >
        <Radio value={TransactionTypeFilter.Debit}>
          {t('bank_transactions.filter.incoming')} <Icon icon="arrowDownLeft" />
        </Radio>
        <Radio value={TransactionTypeFilter.Credit}>
          {t('bank_transactions.filter.outgoing')} <Icon icon="arrowUpRight" />
        </Radio>
      </RadioGroup>
    </>
  )
}
